import { mapState, mapGetters } from 'vuex';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
export default {
  name: 'CoreAlarmLogsReportWizardMetaData',
  components: {
    MarkdownItVueLight
  },
  props: {
    reportModel: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      markdownEdit: false,
      editModel: null,
      accounts: []
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'color']),
    ...mapGetters({
      isFeatureFlagEnabled: 'app/isFeatureFlagEnabled'
    }),
    requiredRule() {
      return [v => !!v || this.$i18n_t('Common.fieldRequired')];
    },
    reportTypes() {
      return [{
        name: this.$i18n_t('AlarmLogs.reports.wizard.reportTypes.device'),
        id: 'virtual-device--health-state'
      }, {
        name: this.$i18n_t('AlarmLogs.reports.wizard.reportTypes.packetMonitoring'),
        id: 'smartgroup-packet-monitoring'
      }];
    }
  },
  watch: {
    reportModel: {
      handler: function () {
        this.editModel = cloneDeep(this.reportModel);
      },
      deep: true,
      immediate: true
    },
    editModel: {
      handler: function () {
        // only publish changes if an actual value did change, not just a new cloned instance got assigned
        if (JSON.stringify(this.editModel) !== JSON.stringify(this.reportModel)) {
          this.publishChanges();
        }
      },
      deep: true
    },
    'editModel.filters.originType'() {
      if (this.editModel.filters.originType === 'smartgroup-packet-monitoring') {
        this.editModel.filters.categories = ['packet-threshold'];
      }
    }
  },
  created() {
    this.fetchAccounts();
  },
  methods: {
    fetchAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        // filter the root-tenant, because that one does not have a twin to attach the new device to
        this.accounts = accounts.filter(t => !t.isRootTenant);
      }).catch(error => {
        console.error(error);
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingAccounts'), 'error');
      });
    },
    publishChanges: debounce(function () {
      this.$emit('change', this.editModel);
    }, 250)
  }
};